import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {GIA_REQUEST} from "../giaReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GIA_REQUEST}${START}`:
            return true;
        case `${GIA_REQUEST}${SUCCESS}`:
            return false;
        case `${GIA_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};